module.exports = __webpack_public_path__ + "static/media/hcs-mark.785f6773.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/hcs-mark.png
// module id = 1794
// module chunks = 15